/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Vekn_Required_For_RolesInputs */



/**
* | output |
* | --- |
* | "User must have a VEKN ID to be assigned roles" |
*
* @param {User_Vekn_Required_For_RolesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_vekn_required_for_roles = /** @type {((inputs?: User_Vekn_Required_For_RolesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Vekn_Required_For_RolesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'utilisateur doit avoir un VEKN ID pour se voir attribuer des rôles")
	if (locale === "es") return /** @type {LocalizedString} */ ("El usuario debe tener un ID VEKN para que se le asignen roles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O usuário deve ter um VEKN ID para receber funções")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'utente deve avere un VEKN ID per essere assegnato a ruoli")
	return /** @type {LocalizedString} */ ("User must have a VEKN ID to be assigned roles")
});